import { Outlet } from '@tanstack/react-router';
import Loader from '@zeus/core/Loader';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import DeliverySection from '_/common/components/layout/DeliverySection';
import { useDeliveryContext } from '_/contexts/DeliveryContext';
import React, { ReactElement, Suspense } from 'react';

const SelectedDeliveryContent = (): ReactElement => {
  const { isLoading } = useDeliveryContext();

  return (
    <Suspense fallback={<Loader />}>
      <AsyncPageContainer isLoading={isLoading}>
        <Outlet />
      </AsyncPageContainer>
    </Suspense>
  );
};

const SelectedDelivery = (): ReactElement => {
  return (
    <DeliverySection>
      <SelectedDeliveryContent />
    </DeliverySection>
  );
};

export default SelectedDelivery;
